import { Http } from '@/lib/http';

export class AgeClassificationService extends Http {
  constructor() {
    super();
    this.endpoint =
      'settings/system-settings/miscellaneous-settings/age-classification';
  }

  getAgeClassification() {
    return this.httpClient().get(this.endpoint);
  }

  createAgeClassification(payload) {
    return this.httpClient().post(this.endpoint, payload);
  }

  updateAgeClassification(id, payload) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, payload);
  }
}
